/** Aligned with payment-link SafeId and v2026 URL-safe IDs. */
export const INVOICE_NUMBER_REGEX = /^[A-Za-z0-9._:-]+$/;

export const INVOICE_NUMBER_INVALID_CHARS_MSG =
  "Only letters, numbers, and . _ : - are allowed (no spaces or slashes)";
